import { NewPaperWithPadding as Paper } from '@components/Misc';
import { WrapperEntitySelector, TextInput } from '@components/Inputs';
import { Typography, Grid } from '@ts/storybook';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { CKPIOperation, IForm, TMode } from '@ts/ui-models';
import KpiOperationInputs from './KpiOperationInputs';

interface IKpiOperationFormProps extends IForm {
  values: CKPIOperation;
}

const KpiOperationForm = ({ mode, ...props }: IKpiOperationFormProps) => {
  const isViewMode = mode == 'view';
  const { values, onCallbackChange, requiredFields } = props;

  //#region Handlers

  const onChangeOperationType = (entity: any) => {
    let value: any = null;
    if (entity) {
      value = entity.getID();
      if (value === values.kpiOperationTypeId) return;
      switch (value) {
        case 'inter_event_item_usage':
        case 'time_between_events':
        case 'interval_summation':
          onCallbackChange('data')({
            startEventType: defaultKPIOpEventTypeData(),
            endEventType: defaultKPIOpEventTypeData(),
            maxThreshold: defaultThresholdData(),
            minThreshold: defaultThresholdData(),
          });
          break;
        case 'count_events':
          onCallbackChange('data')({ eventType: defaultKPIOpEventTypeData() });
          break;
        default:
          break;
      }
    }
    onCallbackChange('kpiOperationTypeId')(value);
    onCallbackChange('kpiOperationType')(entity);
  };

  const handleDeepChange = (attrPath: string, value: any) => {
    onCallbackChange(attrPath as keyof CKPIOperation)(value);
  };

  const renderInputs = () => {
    let kpiOpTypeId = values.kpiOperationTypeId;
    if (!kpiOpTypeId) return;
    return <KpiOperationInputs {...props} disabled={isViewMode} type={kpiOpTypeId} onChangeData={handleDeepChange} />;
  };

  //#endregion

  //#region Functions
  const defaultKPIOpEventTypeData = () => {
    return {
      eventTypeId: null,
      parameter: { type: null, value: null },
    };
  };

  const defaultThresholdData = () => {
    return {
      enabled: false,
      value: 0,
    };
  };

  //#endregion

  return (
    <Grid container size={12}>
      <Paper>
        <Grid container spacing={8}>
          <Grid container direction="column" spacing={2} size={6}>
            <Typography variant="h6" gutterBottom text="KPI Operation" />
            <TextInput
              isReadOnly={isViewMode}
              label="Name"
              value={values.name}
              onChangeValue={onCallbackChange('name')}
              required={requiredFields.includes('name')}
            />
            <TextInput isReadOnly={isViewMode} label="Notes" value={values.notes} onChangeValue={onCallbackChange('notes')} />
            <WrapperEntitySelector
              label={'Operation selector'}
              searchComponent={generateSearchEntitySelector('kpiOperationType')}
              value={values.kpiOperationTypeId}
              onChangeEntity={onChangeOperationType}
              isReadOnly={isViewMode}
            />
          </Grid>
          <Grid container spacing={2} size={12}>
            {renderInputs()}
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default KpiOperationForm;
